import { AppConfigStructure } from './config';

const stagingConfig: AppConfigStructure = {
  name: 'staging',

  intercom: {
    isOn: true,
  },

  sentry: {
    isOn: true,
    DSN: 'https://0cd6aef08375436998965905c89961c9@sentry.io/1280773',
  },

  eventTracker: {
    isOn: true,
  },

  splitFeatureFlagSystem: {
    isOn: true,
    key: '916cs577b54n6t7jrajdlu82226vkdndsdp7',
  },

  fullStory: {
    isOn: true,
  },

  identityEndpointSlug: 'identity',

  features: {},
};

export default stagingConfig;
